export default class LadzoDropDownMenu {
  constructor(buttonSelector, options = {}) {
    this.button = document.querySelector(buttonSelector);
    this.menu = document.querySelector(options.menu);

    if (!this.button || !this.menu) {
      console.error("Invalid selectors for LadzoDropDownMenu");
      return;
    }

    this.init();
  }

  init() {
    const btn = this.button;
    const menu = this.menu;

    // ARIA
    btn.setAttribute("aria-haspopup", "true");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("role", "button");

    menu.setAttribute("role", "menu");
    menu.setAttribute("aria-hidden", "true");
    menu.style.display = "none";

    menu.querySelectorAll("a").forEach((a) => {
      a.setAttribute("role", "menuitem");
      a.setAttribute("tabindex", "-1");
    });

    // Události
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });

    document.addEventListener("click", (e) => {
      if (!btn.contains(e.target) && !menu.contains(e.target)) {
        this.close();
      }
    });

    btn.addEventListener("keydown", (e) => {
      if (["ArrowDown", "Enter", " "].includes(e.key)) {
        e.preventDefault();
        this.open();
      }
    });

    menu.addEventListener("keydown", (e) => {
      const items = [...menu.querySelectorAll("a")];
      const index = items.indexOf(document.activeElement);

      if (e.key === "ArrowDown") {
        e.preventDefault();
        items[(index + 1) % items.length].focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        items[(index - 1 + items.length) % items.length].focus();
      } else if (e.key === "Escape") {
        e.preventDefault();
        this.close();
        btn.focus();
      }
    });
  }

  open() {
    const menu = this.menu;
    const btn = this.button;

    // zavřít ostatní otevřené menu
    document.querySelectorAll(".ladzo-opened").forEach((b) => {
      b.classList.remove("ladzo-opened");
      b.setAttribute("aria-expanded", "false");
    });
    document.querySelectorAll('ul[role="menu"]').forEach((m) => {
      m.style.display = "none";
      m.setAttribute("aria-hidden", "true");
    });

    // otevřít tento
    menu.style.display = "block";
    menu.setAttribute("aria-hidden", "false");

    btn.setAttribute("aria-expanded", "true");
    btn.classList.add("ladzo-opened");

    const first = menu.querySelector("a");
    if (first) first.focus();
  }

  close() {
    this.menu.style.display = "none";
    this.menu.setAttribute("aria-hidden", "true");
    this.button.setAttribute("aria-expanded", "false");
    this.button.classList.remove("ladzo-opened");
  }

  toggle() {
    if (this.menu.style.display === "none" || this.menu.style.display === "") {
      this.open();
    } else {
      this.close();
    }
  }
}
